module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hazards/hazards.component.scss
// module id = ./src/app/hazards/hazards.component.scss
// module chunks = main